import * as React from 'react';
import ReportAbuseModalComp from '../../components/modals/reportAbuseModal';
import { connect } from 'react-redux';
import { reportItem } from '@shared/actions/thunkActions';
export const mapStateToProps = (state, ownProps)=>{
    const { appId, reviewId, reviewTitle, reviewSource, dismissModal } = ownProps;
    return {
        appId,
        reviewId,
        reviewTitle,
        reviewSource,
        dismissModal,
        storefrontName: state.config.storefrontName
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        reportReview: (report)=>dispatch(reportItem(report))
    };
};
export const ReportAbuseModal = connect(mapStateToProps, mapDispatchToProps)(ReportAbuseModalComp);
